// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";

const BASE_URI = "/tenantsettings/";

export default {
  /**
   * Gets the tenant setting value
   * @param {string} settingId - setting id
   * @returns {Promise<object>} - setting value
   */
  getValue(settingId: string) {
    return backend.get(BASE_URI + settingId);
  },
};
